<template>
    <div class="h-[77px] bg-primary-500/75 text-white uppercase flex items-center">{{ label }}</div>
</template>

<script>
export default {
    props: {
        projekt: null,
    },

    computed: {
        label() {
            if(
                this.projekt.r_vertriebsstatus === 'VERKAUFT' &&
                ['ZWEITMARKT', 'ZWEITMARKT_ABVERKAUFT', 'ZWEITMARKT_WE_ANZAHL', 'FREMDOBJEKT', 'FREMDOBJEKT_ABVERKAUFT', 'FREMDOBJEKT_WE_ANZAHL'].includes(this.projekt.r_label)
            ) {
                return `Keine Eigentumswohnungen verfügbar`
            } else if(
                this.projekt.r_vertriebsstatus === 'VERKAUFT' &&
                ['REFERENZ', 'REFERENZ_ABVERKAUFT', 'REFERENZ_WE_ANZAHL'].includes(this.projekt.r_label)
            ) {
                return `Referenz | ${this.projekt.anzahl_wohneinheiten} Eigentumswohnungen`
            } else {
                return `${this.projekt.objekte_anzahl} Eigentumswohnungen verfügbar`
            }

        }
    }
}
</script>